import { render } from "./InfoCard.vue?vue&type=template&id=31963fc5&ts=true"
import script from "./InfoCard.vue?vue&type=script&lang=ts"
export * from "./InfoCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__